if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

(function () {

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//Burger Menu funcionality

	// Open and Close Menu
	const btn_Menu = document.querySelectorAll(".burger-cta-js");
	const menu_Section = document.querySelector("#burger-menu-js")
	btn_Menu.forEach(cta => {
		cta.addEventListener('click', (e) => {
			e.preventDefault();
			menu_Section.classList.toggle("open");
			document.querySelector("body").classList.toggle("no-scroll");
		});
	});

	//subnavigation submenu
	const menu_Items = document.querySelectorAll("#burger-menu-js li:has(.sub-sub-menu)");
	let prevMenuItem;
	menu_Items.forEach( element => {
		const Main_Link = element.querySelector("a");
		Main_Link.addEventListener('click', (e) =>{
			e.preventDefault();
			if (prevMenuItem && prevMenuItem != e.target.nextElementSibling) prevMenuItem.classList.remove('active');
			e.target.nextElementSibling.classList.toggle("active");
			prevMenuItem = e.target.nextElementSibling;
		});
	});

	//burger links for valley
	const vallet_links = document.querySelectorAll("#burger-menu-js .sub-sub-menu a")
	vallet_links.forEach(link => {
		link.addEventListener('click',  (e) => {
			if (e.target.hash.length > 1) {
				document.querySelector("#burger-menu-js").classList.remove("open")
			}
		});
	})

	// slick default setting
	let defaulsettings = {
		loop: true,
		speed: 700,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		navigation: {
			nextEl: '.swiper-prev',
			prevEl: '.swiper-next'
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: false
		}
	};

	let Gallery_Swiper = new Swiper(`.gallery-swiper-js`,{
        loop: true,
        speed: 700,
        slidesPerView:"auto",
        centeredSlides:true,
        autoplay:{
            delay:4000,
            disableOnInteraction:false
        },
        keyboard:{
            enabled:true
        },
        pagination: {
            el: "[data-galdots]",
            clickable: true
        }
    });


	// start slider default
	let allSwipper = [];

	document.querySelectorAll('.swiper-js').forEach((element, i) => {

		let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;

		element.setAttribute(`data-swiper-${i}`, "");

		let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);

		allSwipper[i] = swiper;

	});

	document.querySelectorAll('[data-swiper-control]').forEach((mainSlider) => {
		const selectorsLinked = mainSlider.dataset.swiperControl ? JSON.parse(mainSlider.dataset.swiperControl) : [];
		if (selectorsLinked.length < 1) {
			return false;
		}

		const slidersLinked = selectorsLinked
			.map((selector) => {
				return [...document.querySelectorAll(selector)].map((el) => el.swiper);
			})
			.flat();
		mainSlider.swiper.controller.control = slidersLinked;
	});


	//adittional Class Lightbox
	const introLightbox = new LBX('.js-intro-lightbox', {
		customClass: "white-close",
		beforeShow: () => { document.querySelector("body").classList.add("no-scroll")},
		beforeClose: () => { document.querySelector("body").classList.remove("no-scroll")},
	});

	// LBX class overflow
	LBX._instances[0].beforeShow = (e) => {document.querySelector("body").classList.add("no-scroll")};
	LBX._instances[0].beforeClose = (e) => {document.querySelector("body").classList.remove("no-scroll")};

	//LBX room funcionality
	const customLightbox = new LBX('.lbx-rooms-js', {
		
		beforeShow:() =>{
			document.querySelector("body").classList.add("no-scroll")

			let roomSwiper = new Swiper(`.lbx .swiper-room-js`, {
				loop:true,
				speed:700,
				effect: "fade",
				fadeEffect:{
					crossFade: true
				},
				navigation:{
					nextEl:".lbx .swiper-room-next"
				},
				autoplay:{
					delay:4000,
					disableOnInteraction:false
				}
			});
		},

		beforeClose: () =>{
			document.querySelector(".lbx .swiper-room-js").swiper.destroy();
			document.querySelector("body").classList.remove("no-scroll");
			if(document.querySelector(".lbx .amenities-block__list").classList.contains("active")){
				document.querySelector(".lbx .amenities-block__list").classList.remove("active")
				document.querySelector(".lbx .amenitie-js").textContent = "Amenities & features";
			}
		}
	});

	//accordion Funcionality
	let acordionitems = document.querySelectorAll(".accordion-js .tab-js");
	acordionitems.forEach((item) => {
		item.addEventListener("click", (element) => {
			element.target.classList.toggle("active");
			element.target.nextElementSibling.classList.toggle("active");
		});
	});

	// Filter Funcionality 
	function FilterSection(allTabs, sectionTabs, selecNav) {
		const Tabs = document.querySelectorAll(`${allTabs}`);
		const Section = document.querySelectorAll(`${sectionTabs}`);
		const select= document.querySelector(`${selecNav}`);

		if (Tabs) {
			Tabs.forEach(tab => {

				tab.addEventListener('click', function (e) {
					e.preventDefault();
					Tabs.forEach(remove => {
						remove.classList.remove("active")
					});
					let selectItem = e.target;
					selectItem.classList.add("active");

					Section.forEach(section => {
						section.classList.add("no-visible");
						if (section.dataset.filteritem === selectItem.dataset.filter || selectItem.dataset.filter === "all") {
							section.classList.remove("no-visible")
						}
					})

				});
			});
		}

		if(select){
			select.addEventListener("change", (e) => {
				Section.forEach(section => {
					section.classList.add("no-visible");
					if (section.dataset.filteritem === e.target.value|| e.target.value === "all") {
						section.classList.remove("no-visible")
					}
				})
			});
		}
	}


	//Filter Columns
	FilterSection(".columns [data-filter]", ".columns [data-filteritem]","#columns-select");


	//rooms amenities funcionality
	let ctasAmenitys = document.querySelectorAll(".amenitie-js");
	ctasAmenitys.forEach(btn => {
		btn.addEventListener('click', function (e) {
			e.preventDefault();
			const ctaText = e.target;
			const listAmenities = e.target.nextElementSibling;
			if (!listAmenities.classList.contains("active")) {
				listAmenities.classList.add("active");
				ctaText.textContent = "See Less";
			} else {
				listAmenities.classList.remove("active");
				ctaText.textContent = "Amenities & features";
			}
		});
	});
})();